export type TLoggedInUser = {
    username: string;
    firstName?: string;
    lastName?: string;
    profileImage?: string;
    defaultCookbook?: number;
}

export type TCurrentUser = {
    loggedIn: false;
} | {
    loggedIn: true;
    user: TLoggedInUser;
}

export const defaultUser = (): TCurrentUser => {
    return {loggedIn: false};
}

export type TUser = {
    first_name?: string;
    last_name?: string;
    username: string;
    setting: {
        image?: string;
    }
}

export type TViewer = {
    user: TUser;
    is_contributor: boolean;
    is_admin: boolean;
}